import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { CommandRelay } from '../../../shared/commands/command-relay.class';

import { MessageCollationneService } from '../services/message-collationne.service';
import { MessageCollationneDTO } from '../entities/message-collationne-dto.entity';
import { MessageCollationneTLR } from '../entities/message-collationne-tlr.entity';

@Component({
	selector: 'view-message-collationne-dialog',
	templateUrl: 'view-message-collationne-dialog.html',
})
export class ViewMessageCollationneDialogComponent {
	// Gestion globale de la fenetre
	displaySubject = new Subject<boolean>();

	// Informations a afficher
	message!: MessageCollationneDTO;
	numeroMessage!: string;

	constructor( //
		@Inject(MessageCollationneService) private messageCollationneService: MessageCollationneService,
	) {
	}
	
	// Liaison de l'observable servant a commander l'affichage du composant
	private openRelay = new CommandRelay<MessageCollationneDTO>(data => this.open(data));
	@Input() set openSubject(obs: Observable<MessageCollationneDTO> | undefined) {
		this.openRelay.register(obs);
	}

	// Evenements de validation de l'operation en cours
	@Output() messageCreate = new EventEmitter<MessageCollationneTLR>();
	
	/////////////////////////
	// Actions utilisateur //
	/////////////////////////

	open(message: MessageCollationneDTO) {
		this.message = message;
		if (this.message.parcEnConstruction && !this.message.parcNames) {
			this.message.parcNames = this.message.parcEnConstruction;
		}
		this.numeroMessage = this.messageCollationneService.getNumero(message);

		// Affichage de la pop-up
		this.displaySubject.next(true);
	}

	onCancelRequested() {
		this.displaySubject.next(false);
	}
}